import React, { useState } from "react";
import { Button, Steps, theme } from "antd";
import { useContext } from "react";
import { context } from "../context/context";
import { http } from "../services/httpService";
import config from "../services/config.json";
import PlaceDetailForm from "../components/Place/PlaceDetailForm";
import AddMedia from "./../components/Place/AddMedia";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import { NavLink } from "react-router-dom";
const steps = [
    {
        title: "ویرایش جزئیات مکان",
        content: <PlaceDetailForm />,
    },
    {
        title: "انتخاب عکس",
        content: <AddMedia />,
    },
];
const EditPlace = () => {
    const { token } = theme.useToken();
    const [current, setCurrent] = useState(0);
    const {
        addNamePlace,
        isCategorySelected,
        isCountrySelected,
        isProvinceSelected,
        addPhonePlace,
        linkTags,
        textEditorHTML,
        selectedSubCategoryId,
        selectedCategoryId,
        selectedCityId,
        selectedCountry,
        selectedProvince,
        placeFormTag,
        placeId,
        addAddressPlace,
        coverPicId,
        fileListIds,
        setCoverPic,
        setFileList,
        setLatLng,
        setFileListIds,
    } = useContext(context);
    const next = () => {
        if (current === 0) {
            http.post(`${config.parkopoloApi}/api/Place/addPlace`, {
                placeId: placeId,
                title: addNamePlace,
                tags: placeFormTag,
                province: selectedProvince._id,
                country: selectedCountry._id,
                city: selectedCityId,
                village: selectedCityId,
                category: selectedCategoryId,
                subCategory: selectedSubCategoryId,
                data: textEditorHTML,
                links: linkTags,
                phone: addPhonePlace,
                address: addAddressPlace,
            })
                .then((res) => {
                    console.log(res.data.success);
                })
                .catch((err) => {
                    console.log(err);
                });
        }
        setCurrent(current + 1);
    };

    const navigate = useNavigate();
    const handleSendMedia = () => {
        http.post(`${config.parkopoloApi}/api/Place/addMedia`, {
            placeId: placeId,
            coverPic: coverPicId,
            media: fileListIds,
        })
            .then((res) => {
                toast.success("مکان با موفقیت ویرایش شد !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    progress: undefined,
                    theme: "colored",
                    style: { fontFamily: "Vazir" },
                });
                console.log(res.data.success);
            })
            .catch((err) => {
                toast.error("خطایی رخ داد !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    progress: undefined,
                    theme: "colored",
                    style: { fontFamily: "Vazir" },
                });
                console.log(err);
            });
        setLatLng();
        setFileList([]);
        setFileListIds([]);
        setCoverPic([]);
        navigate("/place", { replace: true });
    };

    const items = steps.map((item) => ({
        key: item.title,
        title: item.title,
    }));
    const contentStyle = {
        lineHeight: "260px",
        textAlign: "center",
        color: token.colorTextTertiary,
        backgroundColor: token.colorFillAlter,
        borderRadius: token.borderRadiusLG,
        border: `1px dashed ${token.colorBorder}`,
        marginTop: 16,
    };
    return (
        <div style={{ direction: "ltr" }}>
            <Steps current={current} items={items} />
            <div style={contentStyle}>{steps[current].content}</div>
            <div
                style={{
                    marginTop: 24,
                    textAlign: "left",
                    gap: "10px",
                    display: "flex",
                }}
            >
                {current < steps.length - 1 && (
                    <Button
                        type="primary"
                        onClick={() => next()}
                        disabled={
                            current === 0 &&
                            (!addNamePlace ||
                                addNamePlace === "" ||
                                !isCategorySelected ||
                                !isCountrySelected ||
                                !isProvinceSelected ||
                                !selectedCityId)
                        }
                    >
                        مرحله بعد
                    </Button>
                )}
                {current === steps.length - 1 && (
                    <Button type="primary" onClick={() => handleSendMedia()}>
                        ثبت
                    </Button>
                )}
                {
                    <NavLink to="/place">
                        <Button type="primary" danger>
                            لغو
                        </Button>
                    </NavLink>
                }
                {/* {current > 0 && (
                    <Button
                        style={{
                            margin: "0 8px",
                        }}
                        onClick={() => prev()}
                    >
                        مرحله قبل
                    </Button>
                )} */}
            </div>
        </div>
    );
};
export default EditPlace;
